export default __webpack_public_path__ + "static/media/background-purple-waves.907ac33f.png";